
/**
 * common values used in knowledge base module panels
 */

export default {
	PARAM_KB_ID: "knowledgeBaseId",

	PARAM_CATEGORY_ID: "categoryId",
	PARAM_CATEGORY_GUID: "categoryGuid",
	PARAM_CATEGORY_EXTERNAL_ID: "categoryExternalId",
	PARAM_CATEGORY_IDS: "categoryIds",

	PARAM_ARTICLE_ID: "articleId",
	PARAM_ARTICLE_GUID: "articleGuid",

	PARAM_CONTRIBUTOR_ID: "contributorId",
	PARAM_CONTRIBUTOR_IDS: "contributorIds",

	PARAM_TAG_IDS: "tagIds",
	PARAM_TAG_CONDITION: "tagCondition",

	PARAM_QUERY: 'query',
	PARAM_SORT: 'sort',
	PARAM_PAGE_SIZE: 'pageSize',
	PARAM_PAGE_NUMBER: 'pageNumber',

	PARAM_TERM_ID: "termId"
};



// WEBPACK FOOTER //
// ./src/panels/kb/constants.ts